export const REQUEST_VERIFY_EMAIL = 'app/VerifyEmail/REQUEST_VERIFY_EMAIL';
